import { useEffect, useState } from "react";
import { styled } from "styled-components";
// import Slider from "react-slick";

// import bgImg1 from "../../../images/main/icsky_building.jpg";
import bgImg1 from "../../../images/mainbg/메인01.webp";
// import bgImg1 from "../../../images/mainbg/메인03.png";
import bgImg2 from "../../../images/mainbg/메인02.webp";
// import bgImg3 from "../../../images/wj/DSC07300.png";
import bgImg3 from "../../../images/mainbg/메인03.webp";
// import bgImg2 from "../../../images/resource/images/portfolio_062119.jpg";

// import bgImg3 from "../../../images/resource/images/portfolio_080228.jpg";
import toplogo_w from "../../../images/common/toplogo_w.png";

// import bgVideo from "../../../images/mainbg/bgVideo2025061601.mp4";
import bgVideo1 from "../../../images/mainbg/bgVideo2025062501.mp4";
import bgVideo2 from "../../../images/mainbg/bgVideo2025062502.mp4";

function IntroVideo() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 800);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  
  return (
    <PreviewContainer id={"Main_Slider"}>
      <SlideWrapper>
        <div className="mainWrapper">
          <StyledSlider>
            <div className="video-list">
                <video width="100%" height="100%" poster={bgImg1} autoPlay muted loop preload="none" style={{objectFit:'cover'}}>
                <source src={isMobile?bgVideo1:bgVideo2} type="video/mp4" />
                Your browser does not support the video tag.
                </video>
            </div>
          </StyledSlider>
        </div>
      </SlideWrapper>
    </PreviewContainer>
  );
}

const PreviewContainer = styled.section`
  width: 100%;
  height: 100%;
  /* display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	position: relative; */

  * {
    margin: 0;
  }
`;

const SlideWrapper = styled.div`
  width: 100%;
  height: 55%;
  /* background-color: yellowgreen; */
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledSlider = styled.div`
  width: 100%;
  height: 100%;

  .video-list {
    position: relative;
    z-index: 2;
    width: 100vw;
    height: 100vh;

    @media screen and (max-width: 1700px) {
      width: 100vw;
    }
    @media screen and (max-width: 1560px) {
      width: 100vw;
    }
    @media screen and (max-width: 1400px) {
      width: 100vw;
    }
    @media screen and (max-width: 1275px) {
      width: 100vw;
    }
    @media screen and (max-width: 1168px) {
      width: 100vw;
    }
    @media screen and (max-width: 1077px) {
      width: 100vw;
    }
    @media screen and (max-width: 1000px) {
      width: 100vw;
    }
    @media screen and (max-width: 935px) {
      width: 100vw;
    }
    @media screen and (max-width: 874px) {
      width: 100vw;
    }
    @media screen and (max-width: 825px) {
      width: 100vw;
    }
    @media screen and (max-width: 778px) {
      width: 100vw;
    }
    @media screen and (max-width: 738px) {
      width: 100vw;
    }
    @media screen and (max-width: 699px) {
      width: 100vw;
    }
    @media screen and (max-width: 667px) {
      width: 100vw;
    }
    @media screen and (max-width: 637px) {
      width: 100vw;
    }
    @media screen and (max-width: 609px) {
      width: 100vw;
    }
    @media screen and (max-width: 583px) {
      width: 100vw;
    }
    @media screen and (max-width: 560px) {
      width: 100vw;
    }
    @media screen and (max-width: 400px) {
      width: 100vw;
    }
    @media screen and (max-width: 394px) {
      width: 100vw;
    }
  }
`;
export default IntroVideo;
